import { put, all, takeLatest, select } from "redux-saga/effects";
import * as Actions from "../../actions/global/global";
import { getJWTTokenCall } from "../../../api/user";
import { getContractNumbersApiCall, getValidateContractApiCall, getPaymentStatusApiCall } from "../../../api/account";
import Cookies from "js-cookie";
import { setUserLanguage } from "../../../util/userLanguageUtils";
import { getNotificationBannnerCall, getPlannedMaintenanceCall } from "../../../api/admin";
import { setDomain, getTheToken, checkImpersonateUser } from "../../../util/util";
import { pendoTrack } from "../../../util/pendoUtil";
//START - REDBALL CONFIG
import { SOURCESYSTEM_CONTRACTNUMBER_API, REDBALL_FEATURE_TOGGLE } from "../../../constants/appConstants";
//END - REDBALL CONFIG

export function* getAccountAndUser({ callback }) {
  try {
    let revealCookie = getTheToken();
    yield put(Actions.getCookie(revealCookie));
    const domain = setDomain(window.location.host);

    // This block of code checks if the current domain is either "test.us.development.fleetmatics.com" or "vccp-qa.ebiz.verizon.com".
    if (domain === "test.us.development.fleetmatics.com" || domain === "vccp-qa.ebiz.verizon.com") {
      revealCookie = (Math.random() * new Date()).toString();
      //START - REDBALL CONFIG
      if (REDBALL_FEATURE_TOGGLE) {
        if (checkImpersonateUser()) {
          Cookies.set("tkauth", revealCookie);
        } else {
          Cookies.set("cptoken", revealCookie);
        }
      } else {
        Cookies.set("tkauth", revealCookie);
      }
      //START - REDBALL CONFIG
    }

    const accountAndUserDetails = yield getJWTTokenCall();
    const userData = accountAndUserDetails?.data?.data;

    if (userData?.accessToken && userData?.refreshToken) {
      yield put(Actions.loginSuccess());

      Cookies.set("userLanguage", setUserLanguage(userData));
      sessionStorage.setItem("revealUserLanguage", userData.userLanguage || "en-US");
      yield put(Actions.getAccountUserToken(userData));

      //Restrict Billing and Payment Page for New Zealand
      // if (userData.accountRegionId === "554") {
      //   yield put(Actions.setPermission("viewInvoicesPermission", false));
      //   yield put(Actions.setPermission("managePaymentsPermission", false));
      // }

      // Uncomment if needed
      // yield put(Actions.getBannerMessage());
      // yield put(Actions.getPlannedMaintenance());

      if (callback) {
        callback(false, userData.accountId, accountAndUserDetails);
      }
    }
  } catch (error) {
    const errorMessage = error?.response?.status === 401 ? "Reveal JWT Token invalid" : "Unable to login";
    callback(errorMessage);
    yield put(Actions.loginFailure(error));
  }
}

export function* getValidateContract({ accountNumber, contractNumber, userId, callback }) {
  try {
    const response = yield getValidateContractApiCall(accountNumber, contractNumber, userId);
    yield put(Actions.getValidateContractSuccess(response));
    if (callback) {
      callback("Success", response);
      yield put(Actions.setBannerDisplayOnLanding(false));
    }
  } catch (error) {
    if (callback) {
      callback("Error", error);
      yield put(Actions.setBannerDisplayOnAll(false));
      yield put(Actions.getValidateContractFailure(error));
    }
  }
}
export function* setPermission(name, status) {
  name = name.replace(/\s/g, "");
  name = name.charAt(0).toLowerCase() + name.slice(1) + "Permission";
  if (status === "Disabled") {
    yield put(Actions.setPermission(name, false));
  } else {
    yield put(Actions.setPermission(name, status));
  }
}

export function* getUserPermission({ callback, loginResponseData = {} }) {
  const accountData = yield select((state) => state.ACCOUNT);
  try {
    //Handle permissions from login response (no separate API call needed)
    const isUserPermissionCallbackCalled = true;
    const revealPermissions = loginResponseData?.revealPermissions;
    if (revealPermissions && typeof revealPermissions === "object") {
      const { apiStatus, permissions } = revealPermissions;
      if (apiStatus === true && permissions && Object.keys(permissions).length > 0) {
        // Dispatch all permission updates
        yield all(
          Object.entries(permissions).map(([permKey, status]) => put(Actions.setPermission(permKey, status === "Disabled" ? false : status)))
        );
        yield put(Actions.setRevealPermissionFallBack(false));
        pendoTrack("Customer Portal | Permissions ", {
          status: "Success",
          statusCode: 200,
          accountId: accountData.accountNumber,
        });

        const fullAndReadOnlyPermissions = Object.fromEntries(
          Object.entries(permissions).filter(([key, value]) => value === "Full" || value === "ReadOnly")
        );
        return callback(accountData.userType, fullAndReadOnlyPermissions, isUserPermissionCallbackCalled);
      } else {
        // Backend returned structure but apiStatus false or no permissions
        yield put(Actions.setPermission("customerPortalPermission", false));
        yield put(Actions.setPermission("accountProfilePermission", false));
        yield put(Actions.setPermission("viewInvoicesPermission", false));
        yield put(Actions.setPermission("managePaymentsPermission", false));
        yield put(Actions.setPermission("viewFinancialCasesPermission", false));
        yield put(Actions.setPermission("viewallotherCasesPermission", false));
        yield put(Actions.setPermission("manageyourcontractandservicesPermission", false));

        yield put(Actions.setRevealPermissionFallBack(true));
        pendoTrack("Customer Portal | Permissions ", {
          status: "Failed",
          statusCode: 500,
          accountId: accountData.accountNumber,
        });
      }
    } else {
      // No permissions structure provided -> fallback
      yield put(Actions.setPermission("customerPortalPermission", false));
      yield put(Actions.setPermission("accountProfilePermission", false));
      yield put(Actions.setPermission("viewInvoicesPermission", false));
      yield put(Actions.setPermission("managePaymentsPermission", false));
      yield put(Actions.setPermission("viewFinancialCasesPermission", false));
      yield put(Actions.setPermission("viewallotherCasesPermission", false));
      yield put(Actions.setPermission("manageyourcontractandservicesPermission", false));
      yield put(Actions.setRevealPermissionFallBack(true));
      pendoTrack("Customer Portal | Permissions ", {
        status: "Failed",
        statusCode: 204,
        accountId: accountData.accountNumber,
      });
    }
  } catch (error) {
    console.log("reveal permission error -> ", error);
    yield put(Actions.setPermission("customerPortalPermission", false));
    yield put(Actions.setPermission("accountProfilePermission", false));
    yield put(Actions.setPermission("viewInvoicesPermission", false));
    yield put(Actions.setPermission("managePaymentsPermission", false));
    yield put(Actions.setPermission("viewFinancialCasesPermission", false));
    yield put(Actions.setPermission("viewallotherCasesPermission", false));
    yield put(Actions.setPermission("manageyourcontractandservicesPermission", false));
    yield put(Actions.setRevealPermissionFallBack(true));
    yield put(Actions.setLoader(false));
    pendoTrack("Customer Portal | Permissions ", {
      status: "Failed",
      statusCode: error.response.data.statusCode,
      accountId: accountData.accountNumber,
    });
  }
}
function* getBannerMessage() {
  try {
    const response = yield getNotificationBannnerCall();

    if (response.data.data) {
      yield put(Actions.setBannerMessage(response.data.data));
      yield put(Actions.setBannerDisplayOnLanding(true));
    } else {
      yield put(Actions.setBannerDisplayOnLanding(false));
      console.log(" No Available have Banner Message");
    }
  } catch (error) {
    yield put(Actions.setBannerDisplayOnLanding(false));
    yield put(Actions.setBannerDisplayOnAll(false));
    console.log("getBannerMessage error-> ", error);
  }
}

function* getPlannedMaintenance() {
  try {
    const response = yield getPlannedMaintenanceCall();

    if (response.data.data) {
      yield put(Actions.setPlannedMaintenance(response.data.data));
      yield put(Actions.setDisplayPlannedMaintenance(true));
    } else {
      yield put(Actions.setDisplayPlannedMaintenance(false));
      console.log(" No Available have Planned Maintenance");
    }
  } catch (error) {
    yield put(Actions.setDisplayPlannedMaintenance(false));
    console.log("getPlannedMaintenance error-> ", error);
  }
}

export function* getContractNumbers({ accountNumber, userId, callback, blankPageTimer }) {
  const id = yield select((state) => state.ACCOUNT.accountNumber);
  const regionId = yield select((state) => state.ACCOUNT.regionId);
  try {
    //START - REDBALL CONFIG
    let contractNumbersPostRequest = {
      universalAccountId: id,
    };
    contractNumbersPostRequest = REDBALL_FEATURE_TOGGLE
      ? { ...contractNumbersPostRequest, sourceSystem: SOURCESYSTEM_CONTRACTNUMBER_API, regionId: regionId }
      : { ...contractNumbersPostRequest };
    //END - REDBALL CONFIG
    const response = yield getContractNumbersApiCall(contractNumbersPostRequest);
    if (callback) {
      callback("Success", response);
      yield put(Actions.setBannerDisplayOnLanding(false));
    }
  } catch (error) {
    if (callback) {
      callback("Error", error);
      yield put(Actions.setBannerDisplayOnAll(false));
      yield put(Actions.getContractNumbersFailure(error));
    }
  }
}
//START - REDBALL CONFIG
export function* getPaymentStatus({ paymentStatusPayload, callback }) {
  yield put(Actions.setLoader(true));
  try {
    const response = yield getPaymentStatusApiCall(paymentStatusPayload);
    yield put(Actions.getPaymentStatusSuccess(response));
    if (callback) {
      callback("Success", response);
      yield put(Actions.setBannerDisplayOnLanding(false));
    }
  } catch (error) {
    if (callback) {
      callback("Error", error);
      yield put(Actions.setBannerDisplayOnAll(false));
      yield put(Actions.getPaymentStatusFailure(error));
    }
  }
  yield put(Actions.setLoader(false));
}
//END - REDBALL CONFIG
export default function* globalWatchers() {
  yield all([
    takeLatest(Actions.VALIDATECONTRACTNUMBER, getValidateContract),
    takeLatest(Actions.LOGIN, getAccountAndUser),
    takeLatest(Actions.GET_PERMISSION, getUserPermission),
    takeLatest(Actions.GET_BANNER_MESSAGE, getBannerMessage),
    takeLatest(Actions.GET_PLANNED_MAINTENANCE, getPlannedMaintenance),
    takeLatest(Actions.GET_CONTRACT_NUMBERS, getContractNumbers),
    takeLatest(Actions.GET_PAYMENT_STATUS, getPaymentStatus),
  ]);
}
